<template>
  <wgu-module-card v-bind="$attrs" :moduleName="moduleName" class="wgu-attributetable-win" :icon="icon"
    @windowOpened="onWindowOpen">
    <template v-slot:wgu-win-toolbar>
      <v-row dense class="mx-2">
        <v-col cols="4">
          <div class="summary-text">总保险数量：{{ totalInsuredArea }}亩 总被保险人数量：{{ totalInsuredPeople }}户</div>
        </v-col>
        <v-col cols="2" >
          <v-select dense label="险种信息" v-model="formData.crop_id"
            :items="authorizedCrops"
                item-text="text" item-value="value"
                class="wgu-vector-layer-select wgu-solo-field"
                clearable>
          </v-select>
        </v-col>
        <v-col cols="2" >
        </v-col>
        <v-col cols="3">
          <v-btn color="primary" @click="handleSubmit" class="ks-toolbar-btn" :loading="isLoading" :disabled="isLoading">
            <v-icon left>mdi-table-edit</v-icon>
            查询
          </v-btn>
          <v-btn color="success" @click="exportToExcel" class="ks-toolbar-btn ml-2" :disabled="isLoading || !tableData.length">
            <v-icon left>mdi-file-excel</v-icon>
            导出
          </v-btn>
        </v-col>
      </v-row>
    </template>

    <!-- 加载指示器 -->
    <v-overlay :value="isLoading" absolute class="loading-overlay">
      <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
      <div class="mt-2 white--text">数据加载中...</div>
    </v-overlay>

    <!-- 消息提示框 -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      top
      right
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="snackbar.show = false"
        >
          关闭
        </v-btn>
      </template>
    </v-snackbar>

    <wgu-attributetable ref="attributeTable" :tableData="tableData" :syncTableMapSelection="syncTableMapSelection"
      @selection-changed="onSelectionChanged">
    </wgu-attributetable>
  </wgu-module-card>
</template>

<script>
import ModuleCard from './../modulecore/ModuleCard';
import { Mapable } from '../../mixins/Mapable';
import { ColorTheme } from '../../mixins/ColorTheme';
import InsuranceTable from './InsuranceTable';
import axios from '@/axios';
import VectorLayer from 'ol/layer/Vector';
import Option from '../../const/Option.js';
import * as XLSX from 'xlsx';
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'ks-insurancetable-win',
  inheritAttrs: false,
  props: {
    icon: { type: String, required: false, default: 'table_chart' },
    syncTableMapSelection: { type: Boolean, required: false, default: false }
  },
  data () {
    return {
      moduleName: 'ks-insurancetable',
      options: Option,
      layers: [],
      selLayer: null,
      parcelName: '',
      trusteeName: '',
      disasterHeaders: [],
      tableData: [],
      requestParams: {
        parcelName: '',
        trusteeName: ''
      },
      dialog: false,
      menu: false,
      formData: {
        crop_id: '',
        insured_name: ''
      },
      selectedRows: [],
      selectedItems: [],
      selectedArea: null, // Add this property to store the selected area
      isLoading: false, // Loading state flag
      snackbar: {
        show: false,
        text: '',
        color: 'error', // 'error', 'warning', 'success', 'info'
        timeout: 3000
      }
    }
  },
  created () {
    // this.fetchTableData();
  },
  mixins: [Mapable, ColorTheme],
  components: {
    'wgu-module-card': ModuleCard,
    'wgu-attributetable': InsuranceTable
  },
  watch: {
    parcelName (val) {
      this.requestParams.parcelName = val;
      this.fetchTableData();
    },
    trusteeName (val) {
      this.requestParams.trusteeName = val;
      this.fetchTableData();
    }
  },
  methods: {
    resolveCropFilter () {
      if (!this.formData.crop_id) return '';
      const matched = this.authorizedCrops.find(item => String(item.value) === String(this.formData.crop_id));
      return matched ? matched.text : this.formData.crop_id;
    },
    async fetchTableData () {
      this.isLoading = true; // 设置加载状态为true
      try {
        const requestBody = {
          page: 1,
          page_size: 10000,
          village_code: this.selectedVillage?.place_id,
          ...this.formData,
          crop_id: this.resolveCropFilter()
        };

        // get jwt token
        const jwtToken = localStorage.getItem('jwt');
        if (!jwtToken) {
          throw new Error('JWT token not found in localStorage');
        }

        const headers = {
          Authorization: `Bearer ${jwtToken}`,
          'Content-Type': 'application/json'
        };

        const response = await axios.post('/policies/insurelist', requestBody, { headers });
        this.tableData = response.data.items;
        console.log('Table data:', this.tableData);
        if (response.data.disasterHeaders) {
          this.disasterHeaders = response.data.disasterHeaders;
        }
        // 检查是否有结果数据
        if (!this.tableData || this.tableData.length === 0) {
          this.showMessage('未找到符合条件的数据', 'info');
        }
      } catch (error) {
        console.error('Failed to fetch table data:', error);
        this.showMessage('获取数据失败，请稍后重试', 'error');
      } finally {
        this.isLoading = false; // 无论成功失败都设置加载状态为false
      }
    },
    onWindowOpen () {
      this.fetchTableData();
    },
    onSelectionChanged (selected) {
      this.selectedItems = selected;
    },
    handleSubmit () {
      // 验证查询条件
      // 检查是否选择了行政区域
      if (!this.selectedVillage?.place_id) {
        this.showMessage('请先选择行政区域', 'warning');
        return;
      }
      // 检查是否选择了险种
      if (!this.formData.crop_id) {
        this.showMessage('请选择险种', 'warning');
        return;
      }
      // 条件满足，执行查询
      this.fetchTableData();
    },
    // 显示消息提示的方法
    showMessage (text, color = 'error') {
      this.snackbar.text = text;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },
    async trusteeConfirm () {
      try {
        const response = await axios.post('/?_c=api&_a=upsertAgInputs', {
          ids: this.selectedRows.map(row => row.id),
          ...this.formData
        });
        if (response.data.success) {
          this.dialog = false;
          this.fetchTableData(); // 刷新表格数据
        } else {
          alert('更新失败：' + response.data.message);
        }
      } catch (error) {
        console.error('Failed to update data:', error);
        alert('更新失败，请检查网络连接');
      }
    },
    exportToExcel () {
      try {
        if (!this.tableData || this.tableData.length === 0) {
          this.showMessage('没有可导出的数据', 'warning');
          return;
        }

        // 处理导出数据，确保与表格显示的结构和列名完全一致
        const exportData = this.tableData.map((item) => ({
          序号: item.row_number || '',
          被保险人姓名: item.insured_name || '',
          被保险人组织机构代码身份证号: item.id_number || '',
          农补一卡通卡号: item.bank_card || '',
          地块: item.plot_info || '',
          保险数量亩: item.area_mu ? parseFloat(item.area_mu).toFixed(2) : '',
          保险金额: item.insurance_amount ? parseFloat(item.insurance_amount).toFixed(2) : '0.00',
          总保险费: item.subsidy_premium ? parseFloat(item.subsidy_premium).toFixed(2) : '0.00',
          农户自交保费: item.farmer_premium ? parseFloat(item.farmer_premium).toFixed(2) : '0.00',
          联系电话: item.phone_number || '',
          农户签字: '' // 添加空白列用于签字
        }));

        // 创建工作簿
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(exportData);

        // 设置列宽以便更好地显示内容
        const wscols = [
          { wch: 6 }, // 序号
          { wch: 10 }, // 被保险人姓名
          { wch: 20 }, // 被保险人组织机构代码身份证号
          { wch: 15 }, // 农补一卡通卡号
          { wch: 25 }, // 地块
          { wch: 12 }, // 保险数量亩
          { wch: 12 }, // 保险金额
          { wch: 12 }, // 总保险费
          { wch: 12 }, // 农户自交保费
          { wch: 12 }, // 联系电话
          { wch: 15 } // 农户签字
        ];
        ws['!cols'] = wscols;

        // 添加工作表到工作簿
        XLSX.utils.book_append_sheet(wb, ws, '保险数据');

        // 生成文件名
        const fileName = `保险数据_${new Date().toLocaleDateString()}.xlsx`;

        // 保存文件
        XLSX.writeFile(wb, fileName);
        this.showMessage('导出成功', 'success');
      } catch (error) {
        console.error('导出失败:', error);
        this.showMessage('导出失败，请稍后重试', 'error');
      }
    },

    getInsuranceTypeName (cropId) {
      const insuranceType = this.options.nzSetting.INSURANCE_TYPE.list.find(
        item => item.value === cropId
      );
      return insuranceType ? insuranceType.text : '';
    }
  },
  computed: {
    ...Mapable.computed,
    ...mapState(['authorizedArea']),
    ...mapGetters(['getCodesByType']),
    authorizedCrops () {
      console.log('authorizedArea:', this.authorizedArea);
      // First try to get crops from authorizedArea.results
      if (this.authorizedArea && this.authorizedArea?.length > 0) {
        return this.getCodesByType(this.authorizedArea[0].organize);
      }
      // Fallback to the original getCodesByType method
      return this.getCodesByType('CROP');
    },
    selectedVillage () {
      return this.$store.state.selectedArea;
    },
    /**
     * Reactive property to return the OpenLayers vector layers to be shown in the selection menu.
     */
    displayedLayers () {
      return this.layers
        .filter(layer =>
          layer instanceof VectorLayer &&
          layer.get('lid') !== 'wgu-measure-layer' &&
          layer.get('lid') !== 'wgu-geolocator-layer'
        )
        .reverse();
    },
    // Calculate total insured area from tableData
    totalInsuredArea () {
      if (!this.tableData || this.tableData.length === 0) return 0;
      // Sum up the area from all records
      const total = this.tableData.reduce((sum, item) => {
        const area = Number(item.area_mu || 0);
        return sum + area;
      }, 0);
      return total.toFixed(2); // Format to 2 decimal places
    },
    // Calculate total number of unique insured people
    totalInsuredPeople () {
      if (!this.tableData || this.tableData.length === 0) return 0;
      // Count unique insured people by their IDs or names
      // Assuming insured person is identified by 'insured_name' or similar
      // Adjust the field name according to your actual data structure
      const uniqueInsured = new Set();
      this.tableData.forEach(item => {
        if (item.insured_name) {
          uniqueInsured.add(item.insured_name);
        }
      });
      return uniqueInsured.size;
    }
  }
};
</script>

<style scoped>
/* TODO
    Generalize the positioning concept for windows,
    this interferes with positioning and draggable settings in the app.conf */

.wgu-vector-layer-select,
.search-field {
  margin-top: 25px;
}

.wgu-attributetable-win.wgu-floating {
  top: inherit !important;
  position: relative;
  bottom: 35px;
  height: 90% !important;
}

.wgu-solo-field.v-text-field ::v-deep input {
  caret-color: white !important;
  color: white !important;
}

.wgu-solo-field.v-text-field ::v-deep label {
  color: rgba(255, 255, 255, 0.7) !important;
}

.wgu-solo-field.v-text-field.v-input--is-focused ::v-deep .v-input__slot {
  border-color: white !important;
}

.btn-position {
  margin-top: 10px !important;
}

.ks-toolbar-btn {
  margin-top: 16px !important;
}

.summary-text {
  color: white;
  margin-top: 25px;
  font-size: 14px;
  white-space: nowrap;
}

.loading-overlay {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

/* 提示消息样式 */
.v-snack__content {
  align-items: center;
  justify-content: space-between;
}

.v-snack--top {
  margin-top: 70px;
}
</style>
